// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"292":"22bdf3d828dc32831a1b","706":"4ed0793e403a55e96d05"}[chunkId] + ".css";
};